import * as React from "react";
import { Tooltip as AntTooltip, TooltipProps as AntTooltipProps } from "antd";
import { RenderFunction } from "antd/es/_util/getRenderPropValue";
import { falseOnly } from "../../services/cpln";
import { useAppSelector } from "../../store/hooks";

export const Tooltip: React.FC<AntTooltipProps> = (props) => {
  const theme = useAppSelector((state) => state.theme.theme);

  const title: React.ReactNode | RenderFunction = Array.isArray(props.title) ? (
    <div className="flex flex-col gap-y-1 mx-2 my-1">
      {props.title.map((value, index) => (
        <span key={index}>{value}</span>
      ))}
    </div>
  ) : (
    props.title
  );

  return (
    <AntTooltip
      /* Default */
      color={theme == "light" ? "white" : "#1e1e1e"}
      styles={{
        root: { maxWidth: 550 },
        body: {
          color: theme == "light" ? "#2a2d31" : "white",
          fontFamily: "proxima-nova, sans-serif",
        },
      }}
      /* Specified Preferences */
      {...props}
      /* Override Specified Preferences */
      title={title}
      open={falseOnly(props.open)}
    >
      {props.children}
    </AntTooltip>
  );
};
